package org.example.zone360.pages.dashboard.clubKeywords

import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.Overflow
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.left
import com.varabyte.kobweb.compose.ui.modifiers.maxHeight
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.overflow
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.position
import com.varabyte.kobweb.compose.ui.modifiers.top
import com.varabyte.kobweb.compose.ui.modifiers.transform
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.modifiers.zIndex
import com.varabyte.kobweb.silk.components.icons.fa.FaTrash
import com.varabyte.kobweb.silk.components.icons.fa.FaXmark
import com.varabyte.kobweb.silk.components.icons.fa.IconSize
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import org.example.zone360.components.CommonDropdown
import org.example.zone360.components.CustomSpacer
import org.example.zone360.components.SearchBar
import org.example.zone360.models.CustomKeywordsData
import org.example.zone360.theme.toSitePalette
import org.example.zone360.utils.Strings
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.Position
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px

@Composable
fun DeleteKeywords(
    clubKeywords: List<CustomKeywordsData>,
    onDismiss: () -> Unit,
    breakpoint: Breakpoint,
    toastMessage: (String) -> Unit

) {
    val palette = ColorMode.current.toSitePalette()

    var searchText by remember { mutableStateOf("") }
    var keywordId by remember { mutableStateOf("") }
    var showDeletePopup by remember { mutableStateOf(false) }
    var selectedLanguages by remember { mutableStateOf("All Languages") }

    val languageCode = mapLanguageToCode(selectedLanguages)
    val filteredKeywords = clubKeywords.filter { keyword ->
        val matchesSearch =
            keyword.text.contains(searchText, ignoreCase = true)

        val matchesLanguage =
            selectedLanguages == "All Languages" ||
                    keyword.language.equals(languageCode, ignoreCase = true)

        matchesSearch && matchesLanguage
    }


    if (showDeletePopup){
        DeleteClubKeyWords(
            onDismiss = {
                showDeletePopup = false
            },
            breakpoint = breakpoint,
            sitePalette = palette,
            toastMessage = toastMessage,
            keywordID = keywordId

        )
    }

    Box(
        modifier = Modifier.width(if (breakpoint < Breakpoint.MD) 90.percent else 400.px)
            .height(600.px)
            .position(Position.Fixed)
            .zIndex(99)
            .top(50.percent)
            .left(50.percent)
            .transform { translate((-50).percent, (-50).percent) },
        contentAlignment = Alignment.Center
    ) {
        Box(modifier = Modifier.fillMaxSize().onClick {})

        Box(
            modifier = Modifier.padding(20.px)
                .width(90.percent)
                .height(90.percent)
                .backgroundColor(palette.modalBackgroundColor.rgb)
                .border(1.px, LineStyle.Solid, palette.textFieldBorderColor.rgb)
                .borderRadius(6.px)
                .overflow(Overflow.Hidden)
        ) {

            Column(modifier = Modifier.fillMaxWidth()) {

                Row(
                    modifier = Modifier.fillMaxWidth(),
                    horizontalArrangement = Arrangement.SpaceBetween,
                    verticalAlignment = Alignment.CenterVertically
                ) {
                    SpanText("Delete Keywords", Modifier.fontSize(18.px).fontWeight(600))

                    FaXmark(
                        size = IconSize.LG,
                        modifier = Modifier.cursor(Cursor.Pointer)
                            .onClick { onDismiss() }
                            .color(palette.commonButtonSupportiveTextColor.rgb)
                    )
                }

                CustomSpacer(10.px, 20.px)
                CommonDropdown(
                    height = 42.px,
                    data = Strings.LANGUAGES_LIST,
                    onSelect = {
                        selectedLanguages = it
                    },
                    selectedItem = selectedLanguages,
                    width = 100.percent,
                )
                CustomSpacer(height = 15.px)
                SearchBar(
                    placeholder = "Search Keywords",
                    id = "keyword-search",
                    breakpoint = Breakpoint.LG,
                    onEnterClick = {},
                    onChange = { newSearchText ->
                        searchText = newSearchText
                    },
                    onClick = {},
                    width = 100.percent,
                    showClearButton = false,
                    height = 45.px,
                    borderColor = Colors.Transparent
                )


                CustomSpacer(5.px, 10.px)
                Column(modifier = Modifier.fillMaxWidth().padding(leftRight = 10.px)
                    .maxHeight(335.px)
                    .overflow(overflowX = Overflow.Hidden, overflowY = Overflow.Auto)
                ) {
                    filteredKeywords.forEach { keyword ->
                        Row(
                            modifier = Modifier
                                .fillMaxWidth()
                                .padding(8.px)
                                .borderRadius(6.px)
                                .padding(10.px),
                            horizontalArrangement = Arrangement.SpaceBetween,
                            verticalAlignment = Alignment.CenterVertically
                        ) {
                            SpanText(
                                keyword.text,
                                modifier = Modifier.fontSize(14.px)
                            )
                            FaTrash(
                                modifier = Modifier
                                    .cursor(Cursor.Pointer)
                                    .color(palette.primary.rgb)
                                    .onClick {
                                        keywordId = keyword.id ?: ""
                                        showDeletePopup = true
                                    },
                                size = IconSize.SM
                            )
                        }
                    }
                }
            }
        }
    }
}
